/* index.js */

"use strict";

module.exports = {
    Tree: require("./src/TreeViewComponent")
};
